module.exports = __webpack_public_path__ + "static/media/quickbook_sync.e35f1240.png";